import axios from "axios";
import jwtDecode from "jwt-decode";
//import { toast } from "react-toastify";
//import logger from "./logService";

const tokenKey = "access_token";
const apiURL = process.env.REACT_APP_API_URL;
const axiosApiInstance = axios.create({ baseURL: apiURL,
                                        timeout: 30000, });

// Request interceptor for API calls
axiosApiInstance.interceptors.request.use( async config => {
    const jwt = localStorage.getItem(tokenKey);

    config.headers = { 'Authorization': `Bearer ${jwt}`,
                       'X-Tenant-ID': 'CMR' }
    return config;
  },
  error => {
    Promise.reject(error)
});

axios.interceptors.response.use((responde) => {
    return responde;
}, function (error) {
    const originalRequest = error.config;

    if (error.response.status === 403 && !originalRequest._retry) {
        return axiosApiInstance(originalRequest);
    }

    return Promise.reject(error);
});

export function getJwt() {
    return localStorage.getItem(tokenKey);
}
export function setJwt(jwt) {
    //axios.defaults.headers.common["x-auth-token"] = jwt;
    axios.defaults.headers.common['Authorization'] = `Bearer ${jwt}`;
}
export function getDataJwt() {
    try {
        const jwt = localStorage.getItem(tokenKey);
        return jwtDecode(jwt);
    } catch (error) {
        return null;
    }
}
export default {
    get: axiosApiInstance.get,
    post: axiosApiInstance.post,
    put: axiosApiInstance.put,
    delete: axiosApiInstance.delete
};
